import React from 'react';
import { Switch } from 'react-router-dom';

import Scout from '../pages/Scout';
import NewScout from '../pages/NewScout';
// import Actions from './pages/Actions';
import Events from '../pages/Events';
import Fights from '../pages/EventFights';
import SignIn from '../pages/SignIn';

import Route from './Route';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={SignIn} />
    <Route path="/events" exact component={Events} isPrivate />
    <Route path="/events/:id/fights" exact component={Fights} isPrivate />
    <Route path="/new-scout" exact component={NewScout} isPrivate />
    <Route path="/fights/:id" exact component={Scout} isPrivate />
  </Switch>
);

export default Routes;
